<template>
  <div>
    <v-dialog
      v-model="dialog_setting"
      scrollable
      persistent
      max-width="1000px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title>
          ตั้งค่าข่าวสารและกิจกรรม
          <v-spacer></v-spacer>
          <v-btn icon class="float-right" @click="dialog_setting = false">
            <v-icon>mdi-window-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-tabs v-model="tab" color="primary" grow>
            <v-tab v-for="item in items" :key="item">{{ item }}</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <Tab1Category></Tab1Category>
            </v-tab-item>
            <v-tab-item>
              <Tab2Activity></Tab2Activity>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog_custom_setting"
      persistent
      max-width="1000px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title style="background-color:rgba(227, 236, 238, 0.9);">
          ตั้งค่าข่าวสารและกิจกรรม
          <v-spacer></v-spacer>
          <v-btn icon class="float-right" @click="dialog_custom_setting = false">
            <v-icon>mdi-window-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <Tab2Activity ref="news_filter" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Tab1Category from "./DialogCalendarSettingTabs/Tab1Category.vue";
import Tab2Activity from "./DialogCalendarSettingTabs/Tab2Activity.vue";
export default {
  components: {
    Tab1Category,
    Tab2Activity,
  },
  data() {
    return {
      dialog_setting: false,
      dialog_custom_setting: false,
      tab: null,
      items: ["หมวดหมู่", "ข่าวสารและกิจกรรม"],
    };
  },
  created() {},
  methods: {
    openSetting() {
      // console.log(this.$refs);
      this.dialog_setting = true;
      this.$route.query.id || window.location.pathname == "/calendarweek"
        ? (this.tab = 1)
        : "";
      if (this.$route.query.id) {
        setTimeout(() => {
          this.$refs.news_filter.openCustomSetting("all");
        }, 200);
      }
    },
    openCustomSetting(category_id, position_id) {
      // console.log(category_id);
      this.dialog_custom_setting = true;
      setTimeout(() => {
        this.$refs.news_filter.filterActivityByCategory(
          category_id,
          position_id
        );
      }, 200);
    },
  },
};
</script>
